import React, { useContext, useEffect, useState } from "react";
import "../refund/refund.css";
import "../analytics.css";
import AnalyticsContext from "../analyticsContext";
import { Bar } from "react-chartjs-2";
import AnalyticsKPI from "../AnalyticsKPI";
import { RefundAnalyticsStates } from "./RefundContext";
import NoDataComponent from "../../../reusableComponents/noDataComponent/NoDataComponent";
import ContainerWithTab from "../../../reusableComponents/conatinerWithTabs/ContainerWithTab";
import AnalyticsTable from "../analyticsTable";
import PieChartComponent from "../checkout/subheaders/paymentMethodSplit/PieChartComponent";
import { paymentMethodRefundsSchema } from "./refundTableSchemas";
import { failureTableSchema } from "../overview/overViewTableSchemas";
import { refundFilterSchemaForFailureReason } from "./refundFilterSchema";
import Filter from "../../filters/filter";
import { Skeleton } from "@mui/material";

function Refund() {
  const {
    totalRefunds,
    refundRate,
    approved,
    pending,
    refundValueCountChartData,
    refundTransactionData,
    setModalDataForFailedRefundTransactions,
    failedRefundTransactionTableData,
    failedRefundTransactionChartData,
    singleStartDate,
    startDate,
    endDate,
  } = RefundAnalyticsStates();

  const selectedDropdownValue = useContext(AnalyticsContext);

  const handleSearchbarModalDataForFailureReason = (data) => {
    setModalDataForFailedRefundTransactions(data);
  };

  const showExternalStyling = true;

  return (
    <div>
      <div className="refund-analytics-root">
        <div className="kpi-conatiner">
          {[...Array(4)].map((e, i) => (
            <AnalyticsKPI
              key={i}
              data={
                i === 0
                  ? totalRefunds
                  : i === 1
                    ? refundRate
                    : i === 2
                      ? approved
                      : pending
              }
              showStyling={showExternalStyling}
              selectedDropdownValue={selectedDropdownValue}
              kpiPage={"payment_link_analytics"}
              singleStartDate={singleStartDate}
              startDate={startDate}
              endDate={endDate}
            />
          ))}
        </div>
        <div className="refund-analytics-contnet">
          <ContainerWithTab
            contentStyle={{ height: "400px" }}
            tabs={[
              {
                header: "Refunds",
                tabTitle: "Chart",
                content:
                  refundValueCountChartData?.options &&
                    refundValueCountChartData?.data ? (
                    <Bar
                      data={refundValueCountChartData?.data}
                      options={refundValueCountChartData?.options}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        padding: "28px 24px",
                      }}
                    >
                      <Skeleton
                        variant="rounded"
                        animation="wave"
                        width={"100%"}
                        height={"100%"}
                      />
                    </div>
                  ),
              },
            ]}
          />
          <ContainerWithTab
            filters={
              <Filter
                filteredSchema={refundFilterSchemaForFailureReason}
                handleSearchbarModalData={
                  handleSearchbarModalDataForFailureReason
                }
                useTabStyling={true}
              />
            }
            tabs={[
              {
                header: "Failed Refund Transactions",
                subHeader: "By Transaction Count",
                tabTitle: "Pie Chart",
                content: (
                  <PieChartComponent
                    data={failedRefundTransactionChartData?.chartDataPoints}
                    chartOptions={
                      failedRefundTransactionChartData?.chartOptions
                    }
                    pieChartData={failedRefundTransactionChartData?.chartData}
                  />
                ),
              },
              {
                header: "Failed Refund Transactions",
                subHeader: "By Transaction Count",
                tabTitle: "Table",
                content: (
                  <AnalyticsTable
                    schema={failureTableSchema}
                    data={failedRefundTransactionTableData?.tableData}
                    default_orderBy={"value"}
                  />
                ),
              },
            ]}
          />
          <ContainerWithTab
            tabs={[
              {
                header: "Refund Transactions Category",
                subHeader: "By Transaction Count",
                tabTitle: "Pie Chart",
                content: (
                  <PieChartComponent
                    data={refundTransactionData?.paymentMethodSplitData}
                    pieChartData={refundTransactionData?.chartData}
                    chartOptions={refundTransactionData?.chartOptions}
                  />
                ),
              },
              {
                header: "Refund Transactions Category",
                subHeader: "By Transaction Count",
                tabTitle: "Table",
                content: (
                  <AnalyticsTable
                    schema={paymentMethodRefundsSchema}
                    data={refundTransactionData?.paymentMethodSplitTableData}
                    default_orderBy={"value"}
                  />
                ),
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
export default Refund;
